module.exports = __webpack_public_path__ + "img/history.acbedab3.svg";